import React from 'react';
import { useNavigate } from 'react-router-dom';
import HabcMonitorForm from './Components/HABCMonitor';
import SidebarPageLayout from './SidebarPageLayout';

function HabcMonitorPage() {
  const navigate = useNavigate();
  const userId = localStorage.getItem('userId') || '';

  return (
    <SidebarPageLayout fullBleed>
      <HabcMonitorForm
        open
        asPage
        userId={userId}
        onClose={() => navigate('/home')}
      />
    </SidebarPageLayout>
  );
}

export default HabcMonitorPage;